<template>
  <div class="relative w-full">
    <profile ref="profile" :show="true" @next="next" @leave="leave" />
  </div>
</template>

<script>
import leave from '@/mixins/leave';
import ApiActions from '@/modules/api-actions';
import ScanProcess from '@/modules/scan-process';
import PoseDetector, { MOBILE_SCAN_OPTIONS } from '@/modules/PoseDetector';

import Profile from '@/components/MobileScan2/Tutorial/Profile.vue';

export default {
  name: 'UserProfile',
  mixins: [leave],
  components: {
    Profile,
  },
  mounted() {
    // 填資料與看教學的時間都拿來下載模型
    PoseDetector.preload(MOBILE_SCAN_OPTIONS).catch(e => {
      console.log(`[ERROR] PoseDetector preload failed: ${e.message}`);
    });
  },
  methods: {
    async setProfile() {
      if (!this.$refs.profile.isEdited) {
        return;
      }
      this.$events.startLoading();
      const req = {
        gender: this.$refs.profile.local.gender,
        height: this.$refs.profile.local.height,
        weight: this.$refs.profile.local.weight,
      };
      console.log(JSON.stringify(req));

      try {
        await ApiActions.user.setProfile(req);
      } catch (e) {
        console.log(e.message);
        this.$events.alert(e.message);
      } finally {
        this.$events.stopLoading();
      }
    },
    next() {
      ScanProcess.mobileScanHeight = this.$refs.profile.local.height;
      this.setProfile().then(() => this.$events.goto('MobileScan2/Tutorial'));
    },
  },
};
</script>

<style scoped></style>
